module.exports = __webpack_public_path__ + "img/remote-access.4aef0978.png";